import { Component, effect, model, OnInit } from '@angular/core';
import { OrderStatuses } from "../../shared/models/order.model";
import { I18nModule } from "@spartacus/core";
import { NgbDropdown, NgbDropdownMenu, NgbDropdownToggle } from "@ng-bootstrap/ng-bootstrap";
import { FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: 'sanofi-statuses-dropdown',
  standalone: true,
  imports: [
    I18nModule,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    ReactiveFormsModule,
    FaIconComponent
  ],
  templateUrl: './statuses-dropdown.component.html',
})
export class StatusesDropdownComponent implements OnInit {
  resetStatus = model(false);
  selectedStatuses = model<OrderStatuses[]>();
  protected statuses: OrderStatuses[] = Object.keys(OrderStatuses).map(status => OrderStatuses[status] as OrderStatuses);
  protected statusesForm: FormGroup = new FormGroup({});

  constructor() {
    effect(() => {
      if (this.resetStatus()) {
        this.resetStatus.set(false);
        this.statusesForm.reset();
      }

      if (this.selectedStatuses()) {
        this.statuses.forEach(status => {
          this.statusesForm.patchValue({[status]: this.selectedStatuses().includes(status)}, {emitEvent: false});
        })
      }
    }, {allowSignalWrites: true});
  }

  ngOnInit(): void {
    this.statusesForm = new FormGroup(
      Object.fromEntries(this.statuses.map(status => [status, new FormControl(false, { nonNullable: true })]))
    );
    this.statusesForm.valueChanges.subscribe(value => {
      const selectedValues = Object.keys(this.statusesForm.value).filter(key => this.statusesForm.value[key]) as OrderStatuses[];
      this.selectedStatuses.set(selectedValues);
    });
  }

  protected readonly faTrashCan = faTrashCan;
  protected readonly faChevronDown = faChevronDown;
}
